import Link from "@insite/mobius/Link";
import React from "react";

interface CalloutContentProps {
    data: {
        destination: {
            url: string;
        };
        heading: string;
        image: string;
        text: string;
        imageAlt: string;
    };
    closeMenu: () => void;
}

const CalloutContent = ({ data, closeMenu }: CalloutContentProps) => {
    const { destination, heading, image, text, imageAlt } = data;

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        closeMenu();
    };

    return (
        <li className="megaMenu__column megaMenu__column--callout">
            <Link className="megaMenu__callout-link" href={destination?.url} onClick={handleClick}>
                <div className="megaMenu__callout-imgWrap">
                    <img className="megaMenu__callout-img" src={image} alt={imageAlt} />
                </div>
                <span className="megaMenu__callout-header">{heading}</span>
            </Link>
            <p className="megaMenu__callout-text">{text}</p>
        </li>
    );
};

export default CalloutContent;
